const FOOTNOTE_NUMBERS = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
const FOOTNOTE_LETTERS = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export function getNextAvailableFootnoteChar(used, lastType = null) {
  if (used.size === 0) return "A";

  const hasNumbers = [...used].some((s) => /^[1-9]$/.test(s));
  const hasLetters = [...used].some((s) => /^[A-Z]$/.test(s));

  let preferType;
  if (hasNumbers && hasLetters) {
    preferType = lastType || "number";
  } else if (hasLetters) {
    preferType = "letter";
  } else {
    preferType = "number";
  }

  const range = preferType === "number" ? FOOTNOTE_NUMBERS : FOOTNOTE_LETTERS;
  const next = range.find((c) => !used.has(c));
  if (next) return next;

  const fallback = preferType === "number" ? FOOTNOTE_LETTERS : FOOTNOTE_NUMBERS;
  return fallback.find((c) => !used.has(c)) || "A";
}

export function collectUsedFootnoteSymbols(state) {
  const used = new Set();
  let lastType = null;

  const collect = (char) => {
    if (!char) return;
    const upper = char.toUpperCase();
    used.add(upper);
    if (/^[1-9]$/.test(upper)) lastType = "number";
    else if (/^[A-Z]$/.test(upper)) lastType = "letter";
  };

  // UI doesn't currently allow custom footnotes on dietary lines, but include
  // them for future-proofing in case we add that capability.
  (state.dietaryLines || []).forEach((line) => collect(line.custom_footnote_char));
  (state.dvLines || []).forEach((line) => collect(line.custom_footnote_char));
  (state.linesWithoutDv || []).forEach((line) => collect(line.custom_footnote_char));
  (state.blends || []).forEach((blend) => {
    collect(blend.custom_footnote_char);
    (blend.constituents || []).forEach((c) => collect(c.custom_footnote_char));
  });

  return { used, lastType };
}
